export default __webpack_public_path__ + "static/media/help_icon.558be7a4.svg";